// src/components/Loader.js
import React from 'react';

// Fullscreen Loader Component
const Loader = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div style={styles.overlay}>
      <div style={styles.loader}>
      </div>
    </div>
  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)', // Transparent black background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9999, // Make sure the loader appears on top
  },
  loader: {
    border: '8px solid #f3f3f3',
    borderTop: '8px solid rgb(243, 75, 78)',
    borderRadius: '50%',
    width: '50px',
    height: '50px',
    animation: 'spin 2s linear infinite',
  },
};

export default Loader;
